// UPI redirect status constants
export const MWEB_UPI_REDIRECT_STATUS = {
    SUCCESS: "MWEB_UPI_APP_REDIRECT_SUCCESS",
    FAILURE: "MWEB_UPI_APP_REDIRECT_FAILURE",
} as const;

export const IXIGO_PACKAGE_TO_UPI_SCHEME_MAP: Record<string, string> = {
    "com.phonepe.app": "phonepe://",
    "com.google.android.apps.nbu.paisa.user": "gpay://upi/",
    "net.one97.paytm": "paytmmp://",
    "in.org.npci.upiapp": "bhim://upi/",
    "com.dreamplug.androidapp": "credpay://upi/",
    "money.super.payments": "super://",
};

/** Reverse lookup: scheme URL → package name */
export const IXIGO_UPI_SCHEME_TO_PACKAGE_MAP: Record<string, string> = Object.fromEntries(
    Object.entries(IXIGO_PACKAGE_TO_UPI_SCHEME_MAP).map(([pkg, scheme]) => [scheme, pkg]),
);
